import React from "react";
import { Paper, Typography, useTheme, Theme } from "@mui/material";
import Grid from "@mui/material/Grid";
import PageHeader from "./PageHeader";
import { ShiSpinnerIcon } from "shared-ui/src/components/ShiSpinnerIcon";
const css = (theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  grow: {
    flexGrow: 1,
  },
  fade: {
    opacity: 0.5,
    width: "75%",
    display: "flex",
    minHeight: theme.spacing(40),
  },
  fifty: {
    width: "60%",
  },
});

export default function LoadingOrError({
  loading = false,
  error = false,
  message = "",
  header = "",
  subheader = "",
  headerComponent = undefined,
  suggestions = "",
  navigation = undefined,
}: {
  loading?: boolean;
  error?: boolean;
  message?: string;
  header?: string | string[];
  subheader?: string;
  headerComponent?: React.ReactNode;
  suggestions?: React.ReactNode;
  navigation?: React.ReactNode;
}) {
  const theme = useTheme();
  const styles = css(theme);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 50,
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
          data-testid="loading-or-error"
        >
          <ShiSpinnerIcon />
        </div>
      )}
      {header && (
        <PageHeader
          header={header}
          subheader={subheader}
          headerComponents={headerComponent}
        />
      )}
      <Grid
        container
        alignItems={loading ? "center" : "start"}
        justifyContent="center"
        sx={{ height: "80%", width: "100%" }}
      >
        {!loading && error && (
          <Paper sx={{ width: "100%" }}>
            <Typography component="div" sx={[styles.root, styles.fade]}>
              <div style={styles.grow}>
                <Typography component="div" variant="h4" gutterBottom>
                  {message}
                </Typography>
                {suggestions && (
                  <Typography
                    component="div"
                    variant="subtitle1"
                    sx={styles.fifty}
                  >
                    {suggestions}
                  </Typography>
                )}
              </div>
            </Typography>
          </Paper>
        )}
      </Grid>
    </>
  );
}
